/**
 * Ecran qui suit la connexion par NIP. L'ecran de vente arrive avec la
 * PR 1.5a : en attendant, cet ecran montre l'acces a la vente tel que le
 * decide la garde unique (app/saleGuard.js), le catalogue, la liste des
 * employes et le bouton « Verrouiller » (retour a l'ecran NIP).
 */
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import BlockIcon from '@mui/icons-material/Block';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import CatalogStatus from './CatalogStatus';
import EmployeeChecklist from './EmployeeChecklist';
import { SALE_BLOCK } from './saleGuard';
import { palette } from './theme';

export default function SessionScreen({ session, access, sync, onSync, canSync, onLock, onManagerConfirm }) {
    return (
        <Box data-testid="ecran-session" sx={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3, p: 4, overflowY: 'auto' }}>
            <Box sx={{ width: '100%', maxWidth: 640, display: 'flex', alignItems: 'center', gap: 2 }}>
                <Typography component="h1" data-testid="session-employe" sx={{ fontSize: 32, fontWeight: 800, flex: 1, color: palette.text }}>
                    Bonjour, {session.display_name}
                </Typography>
                <Button variant="outlined" startIcon={<LockOutlinedIcon />} onClick={onLock} sx={{ minHeight: 64 }}>
                    Verrouiller
                </Button>
            </Box>

            <Box
                data-testid="acces-vente"
                data-acces={access.allowed ? 'autorise' : 'bloque'}
                data-raison={access.reason || ''}
                role={access.allowed ? 'status' : 'alert'}
                sx={{
                    width: '100%', maxWidth: 640, display: 'flex', flexDirection: 'column', gap: 2, p: 3, borderRadius: 2,
                    bgcolor: access.allowed ? palette.successTint : palette.errorTint,
                    color: access.allowed ? palette.successOnTint : palette.errorOnTint,
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    {access.allowed ? <CheckCircleIcon sx={{ fontSize: 36 }} aria-hidden="true" /> : <BlockIcon sx={{ fontSize: 36 }} aria-hidden="true" />}
                    <Typography sx={{ fontSize: 24, fontWeight: 800 }}>
                        {access.allowed ? 'Prêt pour la vente' : 'Vente bloquée'}
                    </Typography>
                </Box>
                <Typography sx={{ fontSize: 18 }}>
                    {access.allowed ? 'L\'écran de vente arrive avec la prochaine version de la caisse.' : access.message}
                </Typography>
                {access.reason === SALE_BLOCK.MANAGER_REQUIRED && (
                    <Button variant="contained" color="error" onClick={onManagerConfirm} sx={{ alignSelf: 'flex-start', minHeight: 64 }}>
                        NIP du responsable
                    </Button>
                )}
            </Box>

            <CatalogStatus
                catalogMeta={sync.catalogMeta}
                catalogSync={sync.catalogSync}
                syncing={sync.syncing}
                progress={sync.progress}
                onSync={onSync}
                canSync={canSync}
            />
            <EmployeeChecklist employees={sync.employees} />
        </Box>
    );
}
